<template>
	<div class="table">
		<div class="game" v-if="readyForRender && thisPlayer !== false">
			<div class="result_div">
				<!-- Schieber / Coiffeur -->
				<div v-if="game.modus == 1">
					{{ game.players[0] + '/' + game.players[2] + ' ' + (game.totalpoints[0]+game.totalpoints[2]) + ' : ' + (game.totalpoints[1]+game.totalpoints[3]) + ' ' + game.players[1] + '/' + game.players[3] }}
				</div>
				<!-- Molotow / Habermacher / Schellenjass -->
				<div v-if="game.modus == 2">
					{{ game.players[0] + ' ' + game.totalpoints[0] + ' / ' + game.players[1] + ' ' + game.totalpoints[1] + ' / ' + game.players[2] + ' ' + game.totalpoints[2] + ' / ' + game.players[3] + ' ' + game.totalpoints[3] }}
				</div>
			</div>
			<div class="carpet">
				<div v-if="game.countmode !== false || (first_card_played && game.modus == 1)" class="trumpf" :style="{'background-image': 'url(' + require('../assets/'+this.trumpfs[this.game.countmode]+'.png') + ')'}"></div>
				<div class="menu_toggle" @click="showMenu = !showMenu">
				</div>
				<div class="jasstafel" v-if="1 == 2">
					<table class="jasstafel_table">
						<tr class="no_border">
							<td>Jan</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>124</td>
							<td><img class="habersymbol" src="../assets/rosen.png" /></td>
							<td>{{ romanize(7) }}</td>
						</tr>
					</table>
				</div>
				<div class="menu_div" v-if="showMenu">
					{{ game.id }}
					<p v-if="thisPlayer == 0 && game.players.length == 4" @click="resetGame()" style="cursor:pointer">Neue Runde beginnen</p>
				</div>
				<div class="waitforothers" v-if="game.players.length < 4">
					<p class="gamenumber">{{ this.game.id }}</p>
					<p class="info" v-if="thisPlayer == 0 && game.modus == 1">
						Du bist der Spielleiter!<br>
						Teile obigen Code deinen Jassfreunden per Telefonkonferenz mit...<br>
						Wer rausfällt, kommt mit diesem Code wieder rein.<br>
						Legt die Regeln per Telefonkonferenz fest und sprecht dort zusammen.<br>
						Fahre mit der Maus über die Namen der anderen, um Weise und Striche zu schreiben.<br>
						Stiche nehmt ihr manuell rein und den letzten könnt ihr zurück auf den Tisch legen.
						Klicke auf die Niete da rechts, um eine neue Runde zu beginnen.<br>
					</p>
					<p class="info" v-if="thisPlayer == 0 && game.modus == 2">
						Du bist der Spielleiter und kennst hoffentlich die Habermacherregeln!<br>
						Teile obigen Code deinen Jassfreunden per Telefonkonferenz mit...<br>
						Wer rausfällt, kommt mit diesem Code wieder rein.<br>
						Stiche nehmt ihr manuell rein. Den letzten könnt ihr zurück auf den Tisch legen.<br>
						Fahre mit der Maus über die Namen, um Weise und Striche zu schreiben.<br>
						Weise am Anfang der Runde musst du schreiben, Tischweise sind automatisch.<br>
						Alle Habermacherstriche werden automatisch geschrieben.<br>
						Ist einer am Ende einer Runde über 300 oder hat 3 Habermacher, ist ein Spiel vorbei.
						Trage dann die Striche ein (2. => 1 Strich, 3. => 2 Striche, 4. => 3 Striche).<br>
						Klicke dann auf die Niete da rechts, um ein neues Spiel zu beginnen.<br>
						Die Striche werden mitgenommen.<br>
						Um ganz neu zu beginnen: Alle laden die Seite neu.
					</p>
				</div>
				<div class="trumpfmaker_div" v-if="(game.modus == 1 && first_card_played && game.hands[thisPlayer].length == 8) && game.countmode === false">
					<div class="trumpfbutton" @click="setCountmode(0)"><img title="Schälle" src="../assets/schellen.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(1)"><img title="Eichle" src="../assets/eicheln.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(2)"><img title="Roose" src="../assets/rosen.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(3)"><img title="Schilte" src="../assets/schilten.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(4)"><img title="Obenabe" src="../assets/obenaben.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(5)"><img title="Ondenufe" src="../assets/untenufen.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(6)"><img title="Slalom, fod obe a" src="../assets/slalomoben.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(7)"><img title="Slalom, fod onde a" src="../assets/slalomunten.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(8)"><img title="Guschti" src="../assets/zwischenoben.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(9)"><img title="Mary" src="../assets/zwischenunten.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(10)"><img title="Schälle" src="../assets/schellen33.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(11)"><img title="Eichle" src="../assets/eicheln33.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(12)"><img title="Roose" src="../assets/rosen33.png" /></div>
					<div class="trumpfbutton" @click="setCountmode(13)"><img title="Schilte" src="../assets/schilten33.png" /></div>
				</div>
				<div class="countround_div" v-if="all_cards_played">
					<template v-if="thisPlayer == 0">
						<!--
						<div class="trumpfbutton" @click="setCountmode(0)" :style="{backgroundColor: game.countmode === 0 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/schellen.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(1)" :style="{backgroundColor: game.countmode === 1 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/eicheln.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(2)" :style="{backgroundColor: game.countmode === 2 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/rosen.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(3)" :style="{backgroundColor: game.countmode === 3 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/schilten.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(4)" :style="{backgroundColor: game.countmode === 4 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/obenaben.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(5)" :style="{backgroundColor: game.countmode === 5 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/untenufen.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(6)" :style="{backgroundColor: game.countmode === 6 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/slalomoben.png" /></div>
						<div class="trumpfbutton" @click="setCountmode(7)" :style="{backgroundColor: game.countmode === 7 ? 'rgba(00,150,00,0.6)' : 'transparent'}"><img src="../assets/slalomunten.png" /></div>
					-->
						<div class="trumpfbutton" @click="setMultiplicator(1)" :style="{backgroundColor: game.multiplicator === 1 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">1x</div>
						<div class="trumpfbutton" @click="setMultiplicator(2)" :style="{backgroundColor: game.multiplicator === 2 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">2x</div>
						<div class="trumpfbutton" @click="setMultiplicator(3)" :style="{backgroundColor: game.multiplicator === 3 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">3x</div>
						<div class="trumpfbutton" @click="setMultiplicator(4)" :style="{backgroundColor: game.multiplicator === 4 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">4x</div>
						<div class="trumpfbutton" @click="setMultiplicator(5)" :style="{backgroundColor: game.multiplicator === 5 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">5x</div>
						<div class="trumpfbutton" @click="setMultiplicator(6)" :style="{backgroundColor: game.multiplicator === 6 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">6x</div>
						<div class="trumpfbutton" @click="setMultiplicator(7)" :style="{backgroundColor: game.multiplicator === 7 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">7x</div>
						<div class="trumpfbutton" @click="setMultiplicator(8)" :style="{backgroundColor: game.multiplicator === 8 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">8x</div>
						<div class="trumpfbutton" @click="setMultiplicator(9)" :style="{backgroundColor: game.multiplicator === 9 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">9x</div>
						<div class="trumpfbutton" @click="setMultiplicator(10)" :style="{backgroundColor: game.multiplicator === 10 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">10x</div>
						<div class="trumpfbutton" @click="setMultiplicator(11)" :style="{backgroundColor: game.multiplicator === 11 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">11x</div>
						<div class="trumpfbutton" @click="setMultiplicator(12)" :style="{backgroundColor: game.multiplicator === 12 ? 'rgba(00,150,00,0.6)' : 'transparent'}" v-if="game.modus != 2">12x</div>
						<div class="oktocount" v-if="!game.oktocount[thisPlayer] && game.countmode !== false" @click="okToCount()">OK</div>
						<div class="oktocountwaiter" v-else>warte auf {{ notoktocount }}</div>
					</template>
					<template v-else>
						<div class="trumpfbutton"><img :src="require('../assets/'+this.trumpfs[this.game.countmode]+'.png')" /></div>
						<div class="trumpfbutton" v-if="game.modus != 2 && game.multiplicator !== false">{{ game.multiplicator }}x</div>
						<div class="oktocount" v-if="!game.oktocount[thisPlayer] && game.countmode !== false && game.multiplicator !== false" @click="okToCount()">OK?</div>
						<div class="oktocountwaiter" v-if="game.oktocount[thisPlayer]">warte auf {{ notoktocount }}</div>
						<div class="oktocountwaiter" v-if="game.multiplicator == false">warte auf Spielleiter</div>
					</template>
				</div>
				<div class="whise_div" v-if="setWhiseFor !== false">
					<div>Weis für {{ game.players[setWhiseFor] }}</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 20)">20</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 50)">50</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 100)">100</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 150)">150</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 200)">200</div>
					<div class="whisebutton" @click="whise(setWhiseFor, 0)">X</div>
				</div>				
				<div class="stroke_div" v-if="setStrokeFor !== false">
					<div>Strich für {{ game.players[setStrokeFor] }}</div>
					<div class="strokebutton" @click="stroke(setStrokeFor, 1)">1x</div>
					<div class="strokebutton" @click="stroke(setStrokeFor, 2)">2x</div>
					<div class="strokebutton" @click="stroke(setStrokeFor, 3)">3x</div>
					<div class="strokebutton" @click="stroke(setStrokeFor, -1)">-</div>
					<div class="strokebutton" @click="stroke(setStrokeFor, 0)">X</div>
				</div>				
				<div v-for="(player, playerIndex) in game.players" :key="player.id">
					<div 
						class="player_div"
						:style="{
							left: playerDivPositions[playerIndex][0] + '%', 
							top: playerDivPositions[playerIndex][1] + '%',
							marginLeft: playerDivPositions[playerIndex][2] + '%',
							transform: 'rotate(' + playerDivPositions[playerIndex][3] + 'deg)',
							backgroundColor: game.laststick === playerIndex ? 'rgba(205,105,0,0.7)' : 'rgba(60,155,55,0.7)'
						}"
					>
						<!-- WHISES -->
						<div 
							v-if="game.whises[playerIndex] !== 0"
							class="whiseCount"
							:class="{'positive': game.whises[playerIndex] > 0, 'negative': game.whises[playerIndex] < 0}"
							:style="{cursor: thisPlayer == 0 ? 'pointer' : 'default'}"
							@click="setWhiseFor = thisPlayer == 0 ? playerIndex : setWhiseFor"
						>
							{{ game.whises[playerIndex] }}
						</div>
						<div 
							v-if="game.whises[playerIndex] == 0 && thisPlayer == 0"
							class="whiseCount hoveronly"
							:style="{
								cursor: thisPlayer == 0 ? 'pointer' : 'default',
								backgroundColor: 'transparent'
							}"
							@click="setWhiseFor = thisPlayer == 0 ? playerIndex : setWhiseFor"
						>
							Weis
						</div>
						<!-- STROKES -->
						<div 
							v-if="game.strokes[playerIndex] > 0"
							class="strokeCount"
							:style="{cursor: thisPlayer == 0 ? 'pointer' : 'default'}"
							@click="setStrokeFor = thisPlayer == 0 ? playerIndex : setStrokeFor"
						>
							{{ romanize(game.strokes[playerIndex]) }}
						</div>
						<div 
							v-if="game.strokes[playerIndex] == 0 && thisPlayer == 0"
							class="strokeCount hoveronly"
							:style="{
								cursor: thisPlayer == 0 ? 'pointer' : 'default',
								backgroundColor: 'transparent'
							}"
							@click="setStrokeFor = thisPlayer == 0 ? playerIndex : setStrokeFor"
						>
							Striche
						</div>
						<!-- HABERMAKERS -->
						<div 
							v-if="game.habermakers[playerIndex] > 0"
							class="haberCount"
						>
							<img v-for="habi in game.habermakers[playerIndex]" :key="habi" class="habersymbol" src="../assets/rosen.png" />
						</div>

						{{ player }}
						<div 
							v-if="game.taken[playerIndex].length"
							class="stickCount"
						>
							{{game.taken[playerIndex].length / 4}}
						</div>
						<div 
							v-if="all_cards_played || game.modus == 2"
							class="pointsCount"
						>
							{{ points[playerIndex] }}
						</div>

					</div>
				</div>
				<!-- Karten auf dem Tisch -->
				<div v-for="(card, playerIndex) in game.stick" :key="card.id">
					<Card
						class="stickCard"
						v-if="card !== false"
						:width="parseInt(120)"
						:size="parseInt(game.carddesk[card].size)" 
						:color="parseInt(game.carddesk[card].color)"
						:style="{
							left: stickPositions[playerIndex][0] + '%', 
							top: stickPositions[playerIndex][1] + '%',
						}"
						@click.native="takeCardBack(playerIndex)"
					></Card>
				</div>
				<div 
					class="takeStick"
					v-if="stickOnTable"
					@click="takeStick()"
				>
				</div>
				<div 
					class="giveStickBack"
					v-if="!stickOnTable && game.taken[thisPlayer].length > 0"
					@click="giveStickBack()"
				>
				</div>

				<div v-for="(player, playerIndex) in game.players" :key="player">
					<div 
						class="takencards_div"
						v-if="all_cards_played"
						:style="{
							left: takenCardsPositions[playerIndex][0] + '%', 
							top: takenCardsPositions[playerIndex][1] + '%',
							marginLeft: takenCardsPositions[playerIndex][2] + '%',
							transform: 'rotate(' + takenCardsPositions[playerIndex][3] + 'deg)'
						}"
					>
						<Card 
							class="takencard"
							v-for="(card, cardIndex) in game.taken[playerIndex]"
							:key="cardIndex"
							:width="parseInt(50)"
							:size="parseInt(game.carddesk[card].size)" 
							:color="parseInt(game.carddesk[card].color)"
						>
						</Card>
					</div>
				</div>

			</div>

			<p class="error" v-if="errortext.length > 0" @click="errortext = ''">{{errortext}}<span style="cursor: pointer;" v-if="errortext.length > 0"></span></p>

			<div class="hand" :style="{width: 120 + (game.hands[thisPlayer].length-1) * 60 + 'px'}">
				<Card 
					class="handCard"
					v-for="(card, cardIndex) in game.hands[thisPlayer]"
					:key="card"
					:width="parseInt(120)"
					:size="parseInt(game.carddesk[card].size)" 
					:color="parseInt(game.carddesk[card].color)"
					@click.native="playCard(cardIndex)"
				>
				</Card>
			</div>
		</div>
		<div class="register" v-if="thisPlayer === false">
			<div class="logo"></div>
			<p class="title">schiltebanner.ch</p>

			<input type="text" v-model="thisPlayerName" placeholder="Name" />
			<p class="text-muted">Gib hier deinen gewünschten Spielernamen ein.</p>
			<input type="text" v-model="newGameID" placeholder="Spiel-Code" />
			<p class="text-muted">Den Spielcode erhälst du telefonisch vom Spielleiter.</p>

			<div class="newTable" v-if="thisPlayerName" @click="startGame(1)">
				<span v-if="!newGameID">Schieber starten</span>
				<span v-if="newGameID.length == 6">Spiel beitreten</span>
			</div>
			<div class="newTable" v-if="thisPlayerName && !newGameID" @click="startGame(2)">
				<span>Habermacher starten</span>
			</div>
			<p class="error" v-if="errortext.length > 0">{{errortext}}</p>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Card from '@/components/Card.vue'
import axios from 'axios'


export default {
	name: 'Home',
	components: {
		Card
	},
	data: () => ({
		readyForRender: false,
		errortext: '',
		newGameID: '',
		game: {									// das ganze Spiel als json
			carddesk: [],
			hands: [[],[],[],[]],
			shuffleDesk: [],
			stick: [],
			taken: [[],[],[],[]],
			totalpoints: [0,0,0,0],
			strokes: [0,0,0,0],
			habermakers: [0,0,0,0],
			whises: [0,0,0,0],
			oktocount: [false,false,false,false],
			players: [],
			id: false,
			countmode: false,
			multiplicator: 1,
			modus: 2,							// 1 = schieber, 2 = einzeln
			laststick: false,
			colorplayed: false					// farbe der ausgespielten Karte (erste Karte des Stichs)
		},								
		thisPlayer: false,							// Nummer des aktiven Spielers (muss dann bei jedem eine andere sein)
		thisPlayerName: '',
		setWhiseFor: false,
		setStrokeFor: false,
		trumpfs: ['schellen', 'eicheln', 'rosen', 'schilten', 'obenaben', 'untenufen', 'slalomoben', 'slalomunten', 'zwischenoben', 'zwischenunten', 'schellen33', 'eicheln33', 'rosen33', 'schilten33'],
		showMenu: false,
		showGiveStickBack: false					// show button to give last stick back?
	}),
	computed: {
		notoktocount() {
			let notok = [];
			for (let i = 0; i < 4; i++) {
				if (!this.game.oktocount[i]) notok.push(this.game.players[i])
			}
			if (notok.length > 1) return 'andere'
			return notok.join(', ')
		},
		stickPositions() {
			// positions of stickcards depending on what player I am
			if (this.thisPlayer == 0) return [ [50, 75], [75, 50], [50, 30], [25, 50] ]
			if (this.thisPlayer == 1) return [ [25, 50], [50, 75], [75, 50], [50, 30] ]
			if (this.thisPlayer == 2) return [ [50, 30], [25, 50], [50, 75], [75, 50] ]
			return [ [75, 50], [50, 30], [25, 50], [50, 75] ]
		},
		playerDivPositions() {
			// positions of stickcards depending on what player I am
			if (this.thisPlayer == 0) return [ [50, 98, -30, 0], [70, 45, 0, 90], [50, -2, -30, 0], [-30, 45, 0, 270] ]
			if (this.thisPlayer == 1) return [ [-30, 45, 0, 270], [50, 98, -30, 0], [70, 45, 0, 90], [50, -2, -30, 0] ]
			if (this.thisPlayer == 2) return [ [50, -2, -30, 0], [-30, 45, 0, 270], [50, 98, -30, 0], [70, 45, 0, 90] ]
			return [ [70, 45, 0, 90], [50, -2, -30, 0], [-30, 45, 0, 270], [50, 98, -30, 0] ]
		},
		takenCardsPositions() {
			// positions of stickcards depending on what player I am: [left, top, margin-left, rotate (in °)]
			if (this.thisPlayer == 0) return [ [50, 60, -22.5, 0], [64, 37, 0, 90], [50, 10, -22.5, 0], [-8, 42, 0, 270] ]
			if (this.thisPlayer == 1) return [ [-8, 42, 0, 270], [50, 60, -22.5, 0], [64, 37, 0, 90], [50, 10, -22.5, 0] ]
			if (this.thisPlayer == 2) return [ [50, 10, -22.5, 0], [-8, 42, 0, 270], [50, 60, -22.5, 0], [64, 37, 0, 90] ]
			return [ [64, 37, 0, 90], [50, 10, -22.5, 0], [-8, 42, 0, 270], [50, 60, -22.5, 0] ]
		},
		stickOnTable() {
			for (let i = 0; i < 4; i++) {
				if (this.game.stick[i] === false) return false
			}
			return true
		},
		all_cards_played() {
			if (!this.stickOnTable && this.game.hands[0].length+this.game.hands[1].length+this.game.hands[2].length+this.game.hands[3].length === 0) return true
			return false
		},
		first_card_played() {
			if (this.game.hands[0].length+this.game.hands[1].length+this.game.hands[2].length+this.game.hands[3].length === 35) return true
			return false
		},
		points() {
			let pointArray = []
			// Habermacher bevor Trumpf ist
			if (this.game.modus == 2) pointArray = [0,0,0,0,10,2,3,4,0,0,0,0,0,10,2,3,4,0,0,0,0,0,10,2,3,4,0,0,0,0,0,10,2,3,4,0]
			// Trumpf ist klar
			if (this.game.countmode === 0) pointArray = [0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 1) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 2) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 3) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11]
			if (this.game.countmode === 4) pointArray = [0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11]
			if (this.game.countmode === 5) pointArray = [11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0]
			if (this.game.countmode === 6) pointArray = [0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11]
			if (this.game.countmode === 7) pointArray = [11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0]
			if (this.game.countmode === 8) pointArray = [0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11,0,0,8,0,10,2,3,4,11]
			if (this.game.countmode === 9) pointArray = [11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0,11,0,8,0,10,2,3,4,0]
			if (this.game.countmode === 10) pointArray = [0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 11) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 12) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11,0,0,0,0,10,2,3,4,11]
			if (this.game.countmode === 13) pointArray = [0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,0,10,2,3,4,11,0,0,0,14,10,20,3,4,11]
			let points = []
			for (let i = 0; i < 4; i++) {
				points[i] = 0
				this.game.taken[i].forEach(card => {
					points[i] += pointArray[card]
				})
				// + 5 für den letzten Stich
				if (this.game.laststick === i && this.all_cards_played) points[i] += 5
			}
			return points;
		}
	},
	created() {
		this.getGame();
		this.interval = setInterval(() => this.getGame(), 2000);
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {

		startGame(modus) {
			if (this.newGameID && this.newGameID.length != 6 || !this.thisPlayerName) return
			// check if there is a code or if a new game is started
			if (!this.newGameID) {
				this.startNewGame(modus);
			} else {
				this.joinGame();
			}
		},
		// römische Zahlen
		romanize(num) {
				if (isNaN(num)) return NaN;
				var digits = String(+num).split(""),
				key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
				"","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
				"","I","II","III","IV","V","VI","VII","VIII","IX"],
				roman = "",
				i = 3;
				while (i--) roman = (key[+digits.pop() + (i * 10)] || "") + roman;
				return Array(+digits.join("") + 1).join("M") + roman;
		},

		startNewGame(modus) {
			axios.post(process.env.VUE_APP_API_URL + '/startnewgame', { player_name: this.thisPlayerName, modus: modus })
			.then(response => this.game = response.data) // Array of Objects
			.then(this.readyForRender = true)
			.then(this.thisPlayer = 0)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		joinGame() {
			axios.post(process.env.VUE_APP_API_URL + '/joingame', { game_id: this.newGameID, player_name: this.thisPlayerName })
			.then(response => {
				this.game = response.data
				this.thisPlayer = response.data.players.findIndex(e => e == this.thisPlayerName)
			})
			.then(this.readyForRender = true)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		getGame() {
			if (!this.game.id) return
			axios.post(process.env.VUE_APP_API_URL + '/getgame', { game_id: this.game.id })
			.then(response => {
				this.game = response.data
				this.thisPlayer = response.data.players.findIndex(e => e == this.thisPlayerName)
			})
			.then(this.readyForRender = true)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		playCard(cardIndex) {
			if (this.game.players.length < 4) return false;
			// Schieber: Wenn erste Karte liegt, warte auf Trumpf
			if (this.game.modus == 1 && this.first_card_played && this.game.countmode === false) {
				this.errortext = 'Wart no uf e Trumpf!'
				if (this.game.hands[this.thisPlayer].length == 8) this.errortext = 'Muesch Trumpf mache!'
				setTimeout(() => this.errortext = '', 3000);
				return
			}
			axios.post(process.env.VUE_APP_API_URL + '/playcard', { game_id: this.game.id, player: this.thisPlayer, card_index: cardIndex})
			.then(response => this.game = response.data) // Array of Objects
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		takeCardBack(playerIndex) {
			if (playerIndex !== this.thisPlayer) return false
			axios.post(process.env.VUE_APP_API_URL + '/takecardback', { game_id: this.game.id, player: this.thisPlayer })
			.then(response => this.game = response.data) // Array of Objects
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		takeStick() {
			axios.post(process.env.VUE_APP_API_URL + '/takestick', { game_id: this.game.id, player: this.thisPlayer })
			.then(response => this.game = response.data) // Array of Objects
			.then(this.showGiveStickBack = true)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		giveStickBack() {
			axios.post(process.env.VUE_APP_API_URL + '/givestickback', { game_id: this.game.id, player: this.thisPlayer })
			.then(response => this.game = response.data) // Array of Objects
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		setCountmode(nr) {
			// Molotov: Nur der Startspieler darf das
			if (this.game.modus == 2 && this.thisPlayer !== 0) return
			// Schieber: Nur der Startspieler darf das, oder der Spieler, der die erste Karte gelegt hat
			if (this.game.modus == 1 && this.game.hands[this.thisPlayer].length !== 8 && this.first_card_played) return
			if (this.game.modus == 1 && this.thisPlayer !== 0 && this.all_cards_played) return
			this.game.countmode = nr;
			axios.post(process.env.VUE_APP_API_URL + '/setcountmode', { game_id: this.game.id, countmode: nr })
			.then(response => this.game = response.data) // Array of Objects
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		setMultiplicator(nr) {
			// Molotov: Nur der Startspieler darf das
			if (this.game.modus == 2 && this.thisPlayer !== 0) return
			// Schieber: Nur der Startspieler darf das
			if (this.game.modus == 1 && this.thisPlayer !== 0) return
			this.game.multiplicator = nr;
			axios.post(process.env.VUE_APP_API_URL + '/setmultiplicator', { game_id: this.game.id, multiplicator: nr })
			.then(response => this.game = response.data) // Array of Objects
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		okToCount() {
			axios.post(process.env.VUE_APP_API_URL + '/oktocount', { game_id: this.game.id, player: this.thisPlayer, points: this.points, whises: this.game.whises })
			.then(response => this.game = response.data) // Array of Objects
			.then(this.showGiveStickBack = false)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		whise(player, points) {
			if (this.thisPlayer !== 0) return
			axios.post(process.env.VUE_APP_API_URL + '/whise', { game_id: this.game.id, player: player, whise: points })
			.then(response => this.game = response.data) // Array of Objects
			.then(this.setWhiseFor = false)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		stroke(player, strokes) {
			if (this.thisPlayer !== 0) return
			axios.post(process.env.VUE_APP_API_URL + '/stroke', { game_id: this.game.id, player: player, strokes: strokes })
			.then(response => this.game = response.data) // Array of Objects
			.then(this.setStrokeFor = false)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		},
		resetGame() {
			if (this.thisPlayer !== 0) return
			axios.post(process.env.VUE_APP_API_URL + '/resetgame', { game_id: this.game.id })
			.then(response => {
				this.game = response.data
				this.thisPlayer = response.data.players.findIndex(e => e == this.thisPlayerName)
			})
			.then(this.showMenu = false)
			.catch(error => {
				this.errortext = error.response.data
				setTimeout(() => this.errortext = '', 3000);
			})
		}		
	}
}
</script>

<style>
body, html {
	margin: 0;
	font-size: 14px;
	background-image: url("../assets/holzboden5.jpg");
	background-size: cover;
	background-position: center center;
}
input {
	font-size: 1.2em;
	border-radius: 0.4em;
	border: 1px solid rgba(0,0,0,0.4);
	background: rgba(255,255,255,0.15);
	padding: 6px 8px;
	margin-bottom: 0;
}
.register {
	background-color: rgba(255,255,255,0.8);
	width: 400px;
	max-width: 80%;
	margin: 10% auto;
	padding: 10px 50px;
	border-radius: 1em;
	box-shadow: 0px 0px 15px black;
}
.register .text-muted {
	color: #222;
	margin-top: 3px;
	font-size: 0.9em;
}
.logo {
	width: 80px;
	height: 80px;
	margin: 10px auto 0;
	border-radius: 50%;
	background-image: url("../assets/schiltebanner.jpg");
	background-position: center center;
	background-size: 110%;
	border: 1px #333 solid;
}
.title {
	text-align: center;
	font-size: 1.4em;
	font-weight: 700;
	margin: 0 0 20px;
}
.table {
	height: 100%;
	padding-top: 60px;
}
.carpet {
	background-image: url("../assets/teppich6.png");
	width: 40em;
	height: 40em;
	margin: 0 auto;
	position: relative;
	background-size: cover;
}
.trumpf {
	height: 30%;
	width: 30%;
	position: absolute;
	left: 50%;
	margin-left: -15%;
	top: 50%;
	margin-top: -17%;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: 30%;
	opacity: 0.6;

}
.waitforothers {
	color: #eee;
	padding-top: 25%;
}
.waitforothers .gamenumber {
	font-size: 3em;
}
.takeStick {
	background-image: url("../assets/down.png");
	background-size: 160%;
	background-position: center -26px;
	width: 60px;
	height: 60px;
	opacity: 0.5;
	position: absolute;
	bottom: 0.8em;
	left: 50%;
	margin-left: -30px;
	cursor: pointer;
}
.takeStick:hover {
	opacity: 1;
}
.giveStickBack {
	background-image: url("../assets/up.png");
	background-size: 100%;
	width: 36px;
	height: 36px;
	opacity: 0.5;
	position: absolute;
	bottom: 2em;
	left: 50%;
	margin-left: -18px;
	cursor: pointer;
	z-index: 3;
}
.giveStickBack:hover {
	opacity: 1;
}
.hand {
	height: 280px;
	margin: 22px auto;
	clear: both;
}
.handCard {
	float: left;
	margin-right: -60px;
	margin-bottom: 10px;
	cursor: pointer;
	transition: all 0.2s;
}
.handCard:hover {
	margin-top: -8px;
}
.stickCard {
	position: absolute;
	margin-left: -60px;
	margin-top: -120px;
}
.player_div {
	position: absolute;
	width: 60%;
	color: #eee;
	font-size: 1.3em;
	border-radius: 0.3em;
	border: 1px solid rgba(0,0,0,1);
}
.stickCount {
	position: absolute;
	right: 10px;
	top: 4px;
	width: 1.3em;
	font-size: 0.6em;
	padding-top: 1px;
	background-color: rgba(255,255,255,0.2);
	border-radius: 50%;
	border: 1px solid rgba(50,50,50,1);
	color: black;
	font-weight: 500;
}
.pointsCount {
	position: absolute;
	right: 30px;
	top: 4px;
	width: 2.3em;
	font-size: 0.6em;
	padding-top: 1px;
	background-color: rgba(255,255,255,0.4);
	border-radius: 0.3rem;
	border: 1px solid rgba(50,50,50,1);
	color: black;
	font-weight: 500;
}
.haberCount {
	position: absolute;
	left: 50px;
	top: 4px;
	height: 1.4em;
	width: 30px;
	padding: 0 4px;
	font-size: 0.6em;
	padding-top: 1px;
	background-color: rgba(255,255,255,0.4);
	border-radius: 0.3rem;
	border: 1px solid rgba(50,50,50,1);
}
.habersymbol {
	width: 10px;
	margin-top: 2px;
	float: left;
}
.whiseCount {
	position: absolute;
	right: 60px;
	top: 4px;
	width: 2.3em;
	font-size: 0.6em;
	padding-top: 1px;
	border-radius: 0.3rem;
	border: 1px solid rgba(50,50,50,1);
	color: black;
	font-weight: 500;
}
.whiseCount.positive {
	background-color: rgba(250,25,25,0.4);
}
.whiseCount.negative {
	background-color: rgba(50,250,250,0.4);
}
.strokeCount {
	position: absolute;
	left: 10px;
	top: 4px;
	width: 3.3em;
	font-size: 0.6em;
	padding-top: 1px;
	background-color: rgba(250,250,125,0.4);
	border-radius: 0.3rem;
	border: 1px solid rgba(50,50,50,1);
	color: black;
	font-weight: 500;
}
.newTable {
	background-image: url("../assets/plus.png");
	background-repeat: no-repeat;
	background-size: 50%;
	background-position: top center;
	width: 128px;
	opacity: 0.8;
	padding-top: 60px;
	margin: 0 auto;
	cursor:pointer;
}
.takencards_div {
	position: absolute;
	width: 40%;
}
.takencard {
	float: left;
	margin-right: -34px;
	margin-bottom: -45px;
}
.trumpfmaker_div {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top:-108px;
	margin-left:-108px;
	width: 200px;
	background-color: rgba(255,255,255,1);
	border-radius: 0.8em;
	border: 2px solid #333;
	padding: 10px;
	z-index: 3;
}
.countround_div {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top:-70px;
	margin-left:-108px;
	width: 200px;
	min-height: 70px;
	background-color: rgba(255,255,255,1);
	border-radius: 0.8em;
	padding: 10px;
	z-index: 3;
}
.trumpfbutton {
	width: 21px;
	height: 22px;
	border-radius: 0.8em;
	padding: 4px;
	cursor: pointer;
	border: 1px #ccc solid;
	float: left;
	margin:1px 1px;
}
.trumpfbutton img {
	width: 20px;
	height: 20px;
}
.oktocount {
	height: 22px;
	border-radius: 0.8em;
	padding: 3px;
	cursor: pointer;
	border: 1px #333 solid;
	clear: left;
	margin-top: 3px;
}
.oktocountwaiter {
	height: 22px;
	border-radius: 0.8em;
	padding: 0px;
	margin-top: 4px;
	clear: left;
}
.result_div {
	background-color: rgba(250,250,250,0.2);
	color: white;
	position: fixed;
	top: 0;
	width: 100%;
	height: 20px;
	padding: 5px;
	text-align: center;
	z-index: 3;
}
.whise_div, .stroke_div {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top:-62px;
	margin-left:-100px;
	height: 50px;
	width: 180px;
	background-color: rgba(255,255,255,0.8);
	border-radius: 0.8em;
	padding: 10px;
}
.whisebutton, .strokebutton {
	width: 21px;
	border-radius: 0.8em;
	padding: 3px;
	cursor: pointer;
	border: 1px #999 solid;
	display: inline-block;
	margin-right:1px;
	font-size: 0.9em;
}
.menu_toggle {
	width: 30px;
	height: 30px;
	position: absolute;
	bottom: 3.2em;
	right: 3.1em;
	cursor: pointer;
}
.jasstafel {
	border: 1px #fff solid;
	border-radius: 1.5em;
	position: absolute;
	width: 60%;
	height: 80%;
	left: 50%;
	top: 10%;
	margin-left: -30%;
	background-image: url("../assets/jasstafel.jpg");
}
.jasstafel_table {
	width: 100%;
	color: white;
	font-size: 1.2em;
	border-collapse: collapse;
}
.jasstafel_table td {
	text-align: center;
	padding: 5px 0 20px;
	border-bottom: 2px solid rgba(255,255,255,0.8);
}
.jasstafel_table tr.no_border td {
	padding: 20px 0 5px;
	border: none !important;
	font-weight: 700;
}
.menu_div {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 200px;
	margin-top:-70px;
	margin-left:-100px;
	background-color: rgba(255,255,255,1);
	border: 2px #333 solid;
	border-radius: 0.8em;
	padding: 10px;
	z-index: 3;
}
.error {
	color: white;
	font-weight: bold;
	padding: 5px 8px;
	margin: 20px 0 0 0;
	border: 1px red dotted;
	display: inline-block;
	border-radius: 0.3rem;
	background-color: rgba(250,55,25,1);
	cursor: pointer;
}
.hoveronly {
	opacity: 0;
}
.player_div:hover * {
	opacity: 1;
}
</style>
